import { connect } from 'react-redux';
import TambahIdentitas2 from '../../../views/Akademi/DataKelas/TambahIdentitas2.view';

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(TambahIdentitas2);
